import { createContext } from 'react';

import type { AnnotationsIntegrationTrackConfig } from '../../core/components/annotations/components/indicators/types.js';
import { TimeseriesChartAnnotationsProps } from '../slots/annotations/Annotations.js';

export interface TimeseriesAnnotationsConfigContextProps
  extends TimeseriesChartAnnotationsProps {
  tracks: AnnotationsIntegrationTrackConfig[];
}
export const defaultConfig: TimeseriesAnnotationsConfigContextProps = {
  tracks: [],
};

export const TimeseriesChartAnnotationsConfigContext =
  createContext<TimeseriesAnnotationsConfigContextProps>(defaultConfig);

TimeseriesChartAnnotationsConfigContext['displayName'] =
  'TimeseriesChartAnnotationsContext';
